<template>
  <img 
    src="/src/assets/icons/ch.svg" 
    alt="Chinese flag"
    class="w-4 h-4 object-cover rounded-sm"
  />
</template> 